import {
  asanaConfig,
  attioConfig,
  clickupConfig,
  featurebaseConfig,
  githubConfig,
  gitlabConfig,
  gmailConfig,
  googleTasksConfig,
  jiraConfig,
  linearConfig,
  microsoftPlannerConfig,
  microsoftTeamsConfig,
  microsoftToDoConfig,
  mondayConfig,
  notionConfig,
  outlookConfig,
  slackConfig,
  tickTickConfig,
  todoistConfig,
  trelloConfig,
  whatsappConfig,
} from "./integrationSyncConfigs";
import type { IntegrationSyncConfig } from "./useIntegrationSyncWorkflow";

/**
 * Task-sync behavior by Membrane integration key.
 *
 * This registry is shared by the settings route and the app-lifetime binding
 * repair. Keeping it outside the route means a ready data collection can be
 * repaired without first navigating to that integration's settings screen.
 */
export const integrationSyncConfigs: Readonly<
  Record<string, IntegrationSyncConfig>
> = {
  gmail: gmailConfig,
  "google-tasks": googleTasksConfig,
  todoist: todoistConfig,
  asana: asanaConfig,
  attio: attioConfig,
  clickup: clickupConfig,
  linear: linearConfig,
  featurebase: featurebaseConfig,
  github: githubConfig,
  gitlab: gitlabConfig,
  jira: jiraConfig,
  "microsoft-planner": microsoftPlannerConfig,
  "microsoft-teams": microsoftTeamsConfig,
  "microsoft-to-do": microsoftToDoConfig,
  "microsoft-outlook": outlookConfig,
  monday: mondayConfig,
  notion: notionConfig,
  slack: slackConfig,
  ticktick: tickTickConfig,
  trello: trelloConfig,
  whatsapp: whatsappConfig,
};
